// Friendly provider names for the Brain picker. The app otherwise shows raw provider keys; these are
// only for the non-technical surface. Falls back to the raw key for anything not listed.
export const PROVIDER_LABELS: Record<string, string> = {
  anthropic: 'Anthropic',
  openai: 'OpenAI',
  google: 'Google Gemini',
  groq: 'Groq'
}

// Seed message for the "describe it in chat" hand-off to the configuration assistant.
export const ASSISTANT_OPENER =
  "Let's set up an assistant. In a sentence — what should it help with? I'll pick a good brain for it, connect anything it needs, and write its instructions. You just confirm."

export type AssistantKind = 'llm' | 'manual' | 'chat' | 'video'

export interface AssistantKindOption {
  key: AssistantKind
  icon: string
  title: string
  desc: string
}

// The choices shown when a user clicks "New assistant". Mounting a model (the "brain") is deliberately
// its own path, separate from configuring an assistant, so creating a model — a provider-validated step
// — never happens silently inside the assistant editor.
export const ASSISTANT_KINDS: AssistantKindOption[] = [
  {
    key: 'llm',
    icon: 'mdi-brain',
    title: 'Add a new brain',
    desc: 'Connect a new model (LLM) your assistants can run on. Start here if you don’t have one yet.'
  },
  {
    key: 'manual',
    icon: 'mdi-account-cog-outline',
    title: 'Build it myself',
    desc: 'Set it up by hand — a name, what it does, the brain it runs on and the tools it can use.'
  },
  {
    key: 'chat',
    icon: 'mdi-message-text-outline',
    title: 'Describe it in Chat',
    desc: 'Tell the assistant what you want in plain language and it builds the whole thing for you.'
  },
  {
    key: 'video',
    icon: 'mdi-video-plus-outline',
    title: 'Show it in a video',
    desc: 'Record yourself doing the task, upload the clip, and it builds the assistant from what you do.'
  }
]
